import {PaymentFlow, PaymentFlowType, PaymentFlowVariant} from "../../apis/requests/payment-flows/types";

const VARIANT_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const FALLBACK_PRIORITY = 0;

export type VariantRow<T extends PaymentFlowType> = PaymentFlowVariant<T> & {key: string; letter: string};

export const isDefaultFlow = (flow: PaymentFlow): boolean => flow.priority === FALLBACK_PRIORITY;

export const matchesAllTransactions = (flow: PaymentFlow): boolean => flow.conditions.rules.length === 0;

export const applyOrder = (baselineIds: number[], override: number[] | null): number[] => {
  if (!override) return baselineIds;
  const overridden = new Set(override);
  if (baselineIds.some((id) => !overridden.has(id))) return baselineIds;
  const live = new Set(baselineIds);
  return override.filter((id) => live.has(id));
};

export const getVariantRows = <T extends PaymentFlowType>(flow: PaymentFlow<T>): VariantRow<T>[] =>
  Object.entries(flow.config.variants).map(([key, variant], index) => ({
    ...variant,
    key,
    letter: VARIANT_LETTERS[index] ?? key,
  }));

export const moveWithinPinned = (
  orderedIds: number[],
  pinnedIds: ReadonlySet<number>,
  activeId: number,
  overId: number
): number[] => {
  const movableIds = orderedIds.filter((id) => !pinnedIds.has(id));
  const fromIndex = movableIds.indexOf(activeId);
  const toIndex = movableIds.indexOf(overId);
  if (fromIndex === -1 || toIndex === -1) return orderedIds;
  const reordered = [...movableIds];
  reordered.splice(toIndex, 0, ...reordered.splice(fromIndex, 1));
  let nextMovable = 0;
  return orderedIds.map((id) => (pinnedIds.has(id) ? id : reordered[nextMovable++]));
};
